import React, { useState, useEffect } from "react";
import * as s from "./Sidebar.styles";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDispatch , useSelector } from "react-redux";
import * as action from '../../../store/actions/index';
import avatarImg from "../../../assets/images/avatar.svg";

const Sidebar = (props) => {
  const location = useLocation();
  let dispatch = useDispatch();
  let userName = useSelector((state) => state.auth.userName);
  let role = useSelector((state) => state.auth.role);
  
  // props
  const { logo = "", menuItems = [] } = props;
  
  // state
  const [activeMenuItem, setActiveMenuItem] = useState(location.pathname);
  const [isSidebarOpen, setSidebarState] = useState(true);

  // fuction
  const onClickMenuItem = (name) => {
    setActiveMenuItem(name);
  };

  // Update of sidebar state
  useEffect(() => {
    const updateWindowWidth = () => {
      if (window.innerWidth < 1550) setSidebarState(false);
      else setSidebarState(true);
     
      
    };

    
    
    window.addEventListener("resize", updateWindowWidth);

    return () => window.removeEventListener("resize", updateWindowWidth);
  }, [isSidebarOpen]);

  useEffect(()=>{
    dispatch(action.authCheckState())
  })

  const menuItemsJSX = menuItems.map((item, index) => {
    const isItemActive = activeMenuItem === item.to;
    return (
      <Link key={index} to={item.to}>
        <s.MenuItem
          active={isItemActive}
          isSidebarOpen={isSidebarOpen}
          onClick={() => onClickMenuItem(item.to)}
        >
          <s.Icon isSidebarOpen={isSidebarOpen} className={item.icon}></s.Icon>
          <s.Text isSidebarOpen={isSidebarOpen}>{item.name}</s.Text>
        </s.MenuItem>
      </Link>
    );
  });

  return (
    <s.SidebarContainer isSidebarOpen={isSidebarOpen}>
      <s.LogoContainer isSidebarOpen={isSidebarOpen}>
        <s.LogoImage src={logo} />
      </s.LogoContainer>

      <s.MenuItemsContainer isSidebarOpen={isSidebarOpen}>
        {menuItemsJSX}
      </s.MenuItemsContainer>

      <s.AvatarContainer isSidebarOpen={isSidebarOpen}>
        <s.AvatarImage src={avatarImg} />
        <s.AvatarTextContair isSidebarOpen={isSidebarOpen}>
          <s.Lead>{userName}</s.Lead>
          <s.AvatarType>{role}</s.AvatarType>
        </s.AvatarTextContair>
      </s.AvatarContainer>
    </s.SidebarContainer>
  );
};

export default Sidebar;
